<template>
  <!-- 회원가입 -->
  <div class="p-member-wrap">
    <div class="c-hgroup is-pc">
      <h1 class="c-title-level1">노루페인트 PAINT PRO 회원가입</h1>
    </div>

    <div class="c-process">
      <ol>
        <li>
          <span class="step-circle"></span>
          <span class="text">약관동의</span>
        </li>
        <!-- D: 현재 단계 is-current 추가 -->
        <li class="is-current" aria-current="step">
          <span class="step-circle"></span>
          <span class="text">정보입력</span>
        </li>
        <li>
          <span class="step-circle"></span>
          <span class="text">가입완료</span>
        </li>
      </ol>
    </div>

    <form action="">
      <div class="c-form-field">
        <label class="c-input-label-group">
          <input type="text" required title="사업자 등록번호" />
          <span class="input-label">사업자 등록번호</span>
        </label>
        <button type="button" class="c-button type-primary type-small">
          <span>조회</span>
        </button>
      </div>

      <div class="c-table-box">
        <div class="table-head flex-between">
          <div class="col">
            <!-- [20241206] id를 한글로 변경 -->
            <strong class="subject">아이디</strong>
            <!-- // [20241206] id를 한글로 변경 -->
          </div>
          <div class="col">
            <span class="system">
              <b>N395719475821</b>
            </span>
          </div>
        </div>
        <div class="table-body">
          <div class="grid">
            <span class="label">특약점명</span>
            <p class="text">
              <b>강남신사노루페인트점</b>
            </p>
          </div>
          <div class="grid">
            <span class="label">대표자명</span>
            <p class="text">
              <b>김노루</b>
            </p>
          </div>
          <div class="grid">
            <span class="label">유선전화</span>
            <p class="text">
              <b>02-000-0000</b>
            </p>
          </div>
          <div class="grid">
            <span class="label">휴대폰번호(대표번호)</span>
            <p class="text">
              <b>010-0000-0000</b>
            </p>
          </div>
          <!-- 20241206: 추가 -->
          <div class="grid colspan">
            <span class="label">이메일</span>
            <p class="text">
              <b>noroo@noroo.com</b>
            </p>
          </div>
          <!-- // 20241206: 추가 -->
        </div>
      </div>

      <div class="form-wrap type-large-gap">
        <div class="c-form-field">
          <label class="c-input-label-group type-password">
            <input type="password" required title="비밀번호" />
            <span class="input-label">비밀번호</span>
            <span class="input-helper"
              >띄어쓰기 없는 영문, 숫자, 특수문자 (!@#$%^*+=-) 포함 8~15자</span
            >
            <button type="button" class="c-btn-icon btn-eye">
              <i class="c-icon icon-eye"></i>
            </button>
            <button type="button" class="c-btn-icon btn-small-delete">
              <span class="c-icon icon-small-x"></span>
            </button>
          </label>
        </div>

        <div class="c-form-field">
          <!-- D: 비밀번호 인풋 type-password 추가 -->
          <label class="c-input-label-group type-password">
            <input type="password" required title="비밀번호 확인" />
            <span class="input-label">비밀번호 확인</span>
            <span class="input-helper"
              >띄어쓰기 없는 영문, 숫자, 특수문자 (!@#$%^*+=-) 포함 8~15자</span
            >
            <button type="button" class="c-btn-icon btn-eye">
              <i class="c-icon icon-eye"></i>
            </button>
            <button type="button" class="c-btn-icon btn-small-delete">
              <span class="c-icon icon-small-x"></span>
            </button>
          </label>
        </div>
        <!-- 20241206: 이메일 필드 삭제 // -->
      </div>

      <div class="c-btn-area">
        <button type="button" class="c-button type-secondary">
          <span>이전단계</span>
        </button>
        <button type="button" class="c-button type-primary">
          <span>회원가입</span>
        </button>
      </div>
    </form>
  </div>
</template>
<script setup name="infoInput"></script>
